import React from 'react';
import styled, { css } from 'styled-components';
import { LFC } from '../Legacy';
import { Roundings, Shadows } from './Standards';
import { toRem } from './Utils';

const Inner = styled.div`
    width: 100%;
    height: 100%;
    border-radius: ${Roundings.md};
    background-color: #fff;
    box-shadow: ${Shadows.xs};
`;

const Frame = styled.div<FloatProps>`
    display: ${p => p.inline ? 'inline-block' : 'block'};
    border-radius: ${Roundings.md};
    box-shadow: ${p => Shadows[p.shadow ?? 'md']};

    ${p => p.border && css`
        ${Inner} {
            border: ${p.border};
            box-shadow: none;
        }
    `}
`;

export type FloatProps = {
    inline?: boolean,
    shadow?: keyof typeof Shadows,
    border?: string,
    width?: string | number,
    height?: string | number,
    style?: any,
};

export const Float: LFC<FloatProps> = ({ children, border, inline, shadow, width, height, style }) => {

    style = style || {} as any;
    if (width) style.width = toRem(width);
    if (height) style.height = toRem(height);

    return <Frame {...{ border, inline, shadow, style }}>
        <Inner>{children}</Inner>
    </Frame >;
};
